<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "StatementOfWorkReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "Workspace",
          key: "workspace",
          type: "text",
          value: undefined
        }
      ],

      historyFilter: "statement_of_work"
    };
  },

  computed: {
    buttonsDisabled() {
      return this.selectedWorkspace === undefined;
    },
    dataToSend() {
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.reportParameters[0].value
        }
      };
    }
  },

  mounted() {
    this.setWorkspaceField();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/StatementOfWork.vue